import { AxiosInstancePlus } from '@tencent/oneid-request';
import { CertifyStatus } from 'common/constants/Constants';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';

export interface ICertifyApi {
  state?: CertifyStatus;
  loginMobile?: string;
}

class CertifyApi {
  axiosInstance: AxiosInstancePlus = http;

  /**
   * 检查是否需要二次认证
   */
  checkCertify(): Promise<IResponseType<ICertifyApi>> {
    return http.get('/admin/v2/certify/check');
  }
}

export default new CertifyApi();
